import React from "react";

/** True when the current grid row is an even-index data row under the modern grid table theme. */
export const ModernGridRowStripeContext = React.createContext(false);

export function useModernGridRowStripe(): boolean {
    return React.useContext(ModernGridRowStripeContext);
}
